<template>
    <div class="GenderF" dir="rtl">
        <div class="AvailableFs">
            <div class="d-flex justify-content-around col-12 p-1 pointer" @click="ToggleBtn">
                <span class="AvailableF-span me-2">مردانه</span>
                <i v-if="$route.query.gender === '1'" class="fa-solid fa-circle-arrow-right oc-icon checked"></i>
                <i v-else-if="$route.query.gender === '0'" class="fa-solid fa-circle-arrow-left oc-icon checked"></i>
                <i v-else class="fa-solid fa-circle-arrow-up oc-icon"></i>
                <span class="AvailableF-span me-2">زنانه</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'GenderF',
  props: {},
  data () {
    return {
      btn: false
    }
  },
  methods: {
    ToggleBtn: function () {
      this.btn = !this.btn
      this.addFilter('gender', this.btn ? '1' : '0')
    }
  }
}
</script>
<style scoped>
.oc-icon{
  left: 0;
  color: #aaaaaa;
  font-size: 18pt;
}
.AvailableF-span{
  color: #4c4b4b;
  font-weight: 500;
  font-size: 14px;
}
.AvailableFs{
  background: #FFFFFF;
  border: solid 2px #e4e4e4;
  border-radius: 9px;
  padding: 10px;
}
.checked{
  color: #e98b78;
}
</style>
